import { preventSkip } from '../../../helpers';

export function zipKeyDownCallBack(e) {
	if (e.key === 'Enter') {
		preventSkip(e);
	}
}
